import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import { SalesOrderDraftStatus } from 'src/types/application/SalesOrderDraftDTO';

interface Props {
  status: SalesOrderDraftStatus;
}

const statusConfig = {
  RECEIVED: { label: 'New', color: '#f9a825' },
  PENDING_REVIEW: { label: 'Pending Review', color: '#ed6c02' },
  APPROVED: { label: 'Approved', color: '#2e7d32' },
  REJECTED: { label: 'Rejected', color: '#d32f2f' },
  PENDING_CHANGES: { label: 'Pending Changes', color: '#ed6c02' },
  ERP_SYNC_FAILED: { label: 'ERP Sync Failed', color: '#d32f2f' },
};

export function SalesOrderDraftStatusBadge({ status }: Props) {
  const config = statusConfig[status as keyof typeof statusConfig] || {
    label: status || 'Unknown',
    color: '#757575',
  };

  return (
    <MDBox
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        py: 0.5,
        borderRadius: '4px',
        backgroundColor: `${config.color}15`,
        border: `1px solid ${config.color}40`,
      }}
    >
      <MDTypography
        variant="caption"
        sx={{
          color: config.color,
          fontWeight: 500,
          fontSize: '0.75rem',
        }}
      >
        {config.label}
      </MDTypography>
    </MDBox>
  );
}
